<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="涉及物品编号">
              <el-input
                clearable
                v-model="queryParamForm.itemCode"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="涉及订单编号">
              <el-input
                clearable
                v-model="queryParamForm.orderCode"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="相关回收商">
              <el-input
                clearable
                v-model="queryParamForm.recyclerName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="结算记录编号">
              <el-input
                clearable
                v-model="queryParamForm.settlementCode"
              ></el-input>
            </el-form-item>
          </el-col>

           <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="结算人">
              <el-input
                clearable
                v-model="queryParamForm.createBy"
              ></el-input>
            </el-form-item>
          </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
            <el-form-item label="结算时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.createTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col>
            <el-button type="primary" @click="getServiceProviderListSearch"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="settlementCode" label="结算编号"> </el-table-column>
        <el-table-column prop="settlementNum" label="结算台数">
        </el-table-column>
        <el-table-column prop="settlementAmount" label="结算金额"></el-table-column>
         <el-table-column prop="settlementAccount" label="结算账号"></el-table-column>
        <el-table-column prop="recyclerName" label="相关回收商"></el-table-column>
        <el-table-column prop="createTime" label="结算时间"> </el-table-column>
        <el-table-column prop="realName" label="结算人">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="details(scope.row)" type="text" size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      title="相关机器及订单"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <!-- 表格 -->
      <el-table :data="tableMappingData" border style="width: 100%" height="400">
        <el-table-column prop="orderCode" label="订单编号"> </el-table-column>
        <el-table-column prop="itemCode" label="物品编号"> </el-table-column>
      </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
          //限制
      pickerOptions1: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
          console.log(obj);
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 60 * 24 * 3600 * 1000;
            let maxTime = this.pickerMinDate + day1;
            let minTime = this.pickerMinDate - day1;
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      // 查询数据
      queryParamForm: {
        itemCode: null,
        orderCode: null,
        recyclerName: null,
        settlementCode: null,
        createBy: null,
        createTime: null
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      tableMappingData:[],

      isDlg: false,

      // 选择
      loading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getServiceProviderListSearch();
    },

    // 获取表格数据
    getServiceProviderListSearch() {
      let self = this;
      self.$api
        .getConsignmentSettlementList({
          page: self.currentPage,
          size: self.pageSize,
          itemCode: self.queryParamForm.itemCode || null,
          orderCode: self.queryParamForm.orderCode || null,
          recyclerName: self.queryParamForm.recyclerName || null,
          settlementCode: self.queryParamForm.settlementCode || null,
          createBy: self.queryParamForm.createBy || null,
          createTimeStart: self.queryParamForm.createTime instanceof Array && self.queryParamForm.createTime.length>1 ? self.queryParamForm.createTime[0] + ' 00:00:00' : null,
          createTimeEnd: self.queryParamForm.createTime instanceof Array && self.queryParamForm.createTime.length>1 ? self.queryParamForm.createTime[1] + ' 23:59:59' : null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },


    // 查看
    details(row) {
      let self = this;
      self.$api
        .getSettlementItemMappingList({settlementCode:row.settlementCode}).then((res)=>{
           self.tableMappingData = res.data
        })
      this.isDlg = false;
      this.$nextTick((e) => {
        self.isDlg = true;
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getServiceProviderListSearch();
  },
};
</script>
<style lang="less" scoped>
</style>
